import React, { FC, useState } from 'react';
import { removeUserFromNotificationDefinitions } from 'state/ducks/notifications/operations';
import { unsubscribeRoutes } from 'state/ducks/routes';
import { i18nTranslationKey, localized } from 'state/i18n';
import { Spinner } from 'view/components/spinner/spinner';
import WhiteCard from 'view/shared/components/cards/white-card';
import { ConfirmDialog } from 'view/shared/components/dialogs/bi-dialog-confirm/dialog-confirm';
import './notification-unsubscribe.scss';

type UnsubscribeStep = 'confirm' | 'unsubscribing' | 'unsubscribed' | 'failed' | 'cancelled';

const cardTitles: Record<UnsubscribeStep, i18nTranslationKey> = {
	confirm: 'Unsubscribe',
	unsubscribing: 'UnsubscribingNotification',
	unsubscribed: 'SuccesfullUnsubscribe',
	failed: 'UnsubscribeFailed',
	cancelled: 'UnsubscribeCancelled',
};

export const UnsubscribeNotifications: FC = () => {
	const [step, setStep] = useState<UnsubscribeStep>('confirm');

	const unsubscribeUser = async () => {
		setStep('unsubscribing');
		let path = window.location.pathname;
		let encryptedString = path.substring(unsubscribeRoutes.path.length);

		try {
			await removeUserFromNotificationDefinitions(encryptedString);
			setStep('unsubscribed');
		} catch {
			setStep('failed');
		}
	};

	const cancelUnsubscribe = () => setStep(current => (current === 'confirm' ? 'cancelled' : current));

	return (
		<div className="unsubscribe-page">
			<div className="unsubscribe-container">
				<WhiteCard title={localized(cardTitles[step])} spaceBetweenTitlesAndContentInEm={0}>
					{step === 'unsubscribing' && (
						<Spinner
							shouldOverlay={false}
							spinnerSize="spinner-container-1-4th-size"
							useMarginsForCorrectingCentering={false}
						/>
					)}
				</WhiteCard>
				<ConfirmDialog
					visible={step === 'confirm'}
					onHide={cancelUnsubscribe}
					onCancel={cancelUnsubscribe}
					onConfirm={unsubscribeUser}
					header={localized('Unsubscribe')}
					dialogMessage={localized('UnsubscribeNotificationConfirmMessage')}
					confirmMessage={localized('Unsubscribe')}
					confirmColor="org-red"
				/>
			</div>
		</div>
	);
};
